import Backdrop from '@mui/material/Backdrop'
import {Loader} from '../1elements'

const LoaderBackdrop = ({open, loaded}) => {
    return (
        <Backdrop open={open} sx={{ zIndex: 10 }}>
            {
                !loaded && <Loader />
            }
        </Backdrop>
    )
}

export default LoaderBackdrop
